export enum HEADER_TYPE {
  HEADING = 'heading',
  HERO_HEADING_FULL_BLEED_IMAGE = 'heroHeadingFullBleedImageBlock',
  HERO_HEADING_CENTERED_IMAGE = 'heroHeadingCenteredImageBlock',
  HERO_HEADING_FULL_BLEED_VIDEO = 'heroHeadingFullBleedVideoBlock',
}
